import { render, staticRenderFns } from "./ContactCustomerContact.vue?vue&type=template&id=2cf2e84a&"
import script from "./ContactCustomerContact.vue?vue&type=script&lang=js&"
export * from "./ContactCustomerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports